import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temp-maintenance-page',
  templateUrl: './temp-maintenance-page.component.html',
  styleUrls: ['./temp-maintenance-page.component.scss']
})
export class TempMaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
